import { styled } from "styled-components";

// 类别跑马灯
export const HomeHeaderCarouselWrapper = styled.div`
  position: relative;

  @media screen and (max-width: ${480}px) {
    .swiper {
      padding: 0 20px;
      padding-top: 20px;
    }
  }

  @media screen and (min-width: ${481}px) {
    .swiper {
      padding: 0 110px;
      padding-top: 30px;
    }
  }

  .leftMask {
    position: absolute;
    left: 0px;
    top: 40px;
    z-index: 2;
  }

  .rightMask {
    position: absolute;
    right: 0px;
    top: 40px;
    z-index: 2;
  }

  .swiperButtonPrev {
    position: absolute;
    left: 35px;
    z-index: 2;
    cursor: pointer;
  }

  .swiperButtonNext {
    position: absolute;
    right: 35px;
    z-index: 2;
    cursor: pointer;
  }
`;
